const SharedPresentation = () => {
  return <div>Shared</div>;
};

export default SharedPresentation;
